var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWarningIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 143 143",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.5,76.15a4,4,0,0,0,4-4V44.2a4,4,0,0,0-8,0v28A4,4,0,0,0,71.5,76.15Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 71.96,
    cy: 97.41,
    r: 7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.83,40.71,102.29,1.17A4,4,0,0,0,99.46,0H43.54a4,4,0,0,0-2.83,1.17L1.17,40.71A4,4,0,0,0,0,43.54V99.46a4,4,0,0,0,1.17,2.83l39.54,39.54A4,4,0,0,0,43.54,143H99.46a4,4,0,0,0,2.83-1.17l39.54-39.54A4,4,0,0,0,143,99.46V43.54A4,4,0,0,0,141.83,40.71ZM135,97.8,97.8,135H45.2L8,97.8V45.2L45.2,8H97.8L135,45.2Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/warning-icon.b21b8e1a2b17b5f01687078945dafae2.svg";
export { ForwardRef as ReactComponent };